<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>统一资源列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="80px" size="small" class="query-form"
        @submit.native.prevent="getList()">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词" style="width:215px;"></el-input>
        </el-form-item>
        <el-form-item label="资源类型">
          <el-select v-model="query.resourceType" filterable clearable @change="selList()">
            <el-option label="全部" value=""></el-option>
            <el-option label="留学" value="留学"></el-option>
            <el-option label="日语" value="日语"></el-option>
            <el-option label="鸣野" value="鸣野"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.state" filterable clearable @change="stateClick()">
            <el-option v-for="item in statelist" :label="item.name" :value="item.id" :key="item.id"
              placeholder="请选择"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划赴日">
          <el-select v-model="query.abroadPlan" filterable clearable @change="schoolClick()">
            <el-option label="请选择" value></el-option>
            <el-option v-for="item in planList" :label="item" :value="item" :key="item" placeholder="请选择"></el-option>
          </el-select>
        </el-form-item>

        <div>
          <el-form-item label="学校">
            <el-select v-model="query.schid" filterable clearable @change="schoolClick()">
              <el-option label="请选择" value></el-option>
              <el-option v-for="item in schoollist" :label="item.label" :value="item.value" :key="item.value"
                placeholder="请选择"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学历">
            <el-select v-model="query.edu" filterable clearable @change="schoolClick()">
              <el-option label="请选择" value></el-option>
              <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"
                placeholder="请选择"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源">
            <el-cascader :options="sourselist" v-model="selectedOrigion" clearable change-on-select
              :props="{ value: 'name', label: 'name', checkStrictly: true }" style="width: 100%"
              @change="stateClick"></el-cascader>
          </el-form-item>
        </div>

        <div>
          <el-form-item label="顾问">
            <DeptRoleTeacherSelect v-model="query.adviserID" dept="留学" placeholder="请选择部门 → 角色 → 老师" @change="schoolClick()" />
          </el-form-item>

          <el-form-item label="营销">
            <DeptRoleTeacherSelect v-model="query.marketID" dept="留学" placeholder="请选择部门 → 角色 → 老师" @change="schoolClick()" />
          </el-form-item>
          <el-form-item label="学生/家长">
            <el-select v-model="query.studentType" placeholder="全部" clearable filterable @change="schoolClick()">
              <el-option v-for="item in studentTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别">
            <el-select v-model="query.sex" placeholder="全部" clearable filterable @change="schoolClick()">
              <el-option label="男" :value="true"></el-option>
              <el-option label="女" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日语状况" label-width="80px">
            <el-select v-model="query.japanese" filterable clearable @change="schoolClick()">
              <el-option v-for="item in japlist" :label="item.name" :value="item.id" :key="item.id"
                placeholder="请选择等级"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="添加时间">
            <el-date-picker v-model="query.daterange" clearable @change="schoolClick()" value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="selList()">查询</el-button>
            <el-button type="success" @click="exportClick()">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>统一资源列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%"
          :row-class-name="tableRowClassName">
          <el-table-column prop="inputTime" label="添加时间"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="age" label="年龄"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <!-- 顾问列：营销人员不显示 -->
          <el-table-column prop="adviserName" label="留学顾问"></el-table-column>
          <el-table-column prop="jpAdviserName" label="日语顾问" :width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.jpAdviserName || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="myAdviserName" label="鸣野顾问" :width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.myAdviserName || '-' }}</span>
            </template>
          </el-table-column>
          <!-- 营销列：按板块标签+老师姓名展示（与跟进状态一致）；顾问人员不显示 -->
          <el-table-column label="营销" :width="150">
            <template slot-scope="scope">
              <div class="market-by-dept">
                <div v-if="scope.row.isStudent" style="margin-bottom: 5px;">
                  <el-tag type="primary" size="mini" style="margin-right: 5px;">留学</el-tag>
                  <span style="font-size: 12px;">{{ scope.row.marketName || '-' }}</span>
                </div>
                <div v-if="scope.row.isJap" style="margin-bottom: 5px;">
                  <el-tag type="success" size="mini" style="margin-right: 5px;">日语</el-tag>
                  <span style="font-size: 12px;">{{ scope.row.jpMarketName || '-' }}</span>
                </div>
                <div v-if="scope.row.isMingye">
                  <el-tag type="warning" size="mini" style="margin-right: 5px;">鸣野</el-tag>
                  <span style="font-size: 12px;">{{ scope.row.myMarketName || '-' }}</span>
                </div>
                <template v-if="!scope.row.isStudent && !scope.row.isJap && !scope.row.isMingye">
                  <span style="font-size: 12px; color: #909399;">-</span>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="来源">
            <template slot-scope="scope">
              <span :title="scope.row.origin">{{ scope.row.origin }}</span>
              <span :title="scope.row.recName">{{ scope.row.recName }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="stuStatusName" label="状态"></el-table-column> -->
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <!-- 已报名显示课程和学费 -->
          <!-- <el-table-column label="报名课程" :width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.hasCourse" :title="scope.row.courseNames">{{ scope.row.courseNames || '-' }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="当月学费" :width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.hasCourse && scope.row.monthPayAmount > 0">{{ scope.row.monthPayAmount.toFixed(2) }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <!-- 该行各板块顾问均为空且当前用户不可编辑时，仅显示查看+分配；管理员等可编辑时仍显示编辑按钮 -->
              <el-button-group v-if="isAllAssignedNoAdviser(scope.row) && !canEditAny(scope.row)">
                <el-tooltip content="查看" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.id"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid" @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.id"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid" @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditAny(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 其他部门跟进详情弹窗（统一组件） -->
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <!-- 分配资源弹框（统一组件）：仅显示学生尚未分配的部门，避免「当前页还分配当前部门」 -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserList"
      :market-list="marketList"
      :user-is-admain="userIsAdmain"
      :show-student="!assignForm.isStudent"
      :show-jap="!assignForm.isJap"
      :show-mingye="!assignForm.isMingye"
      :empty-message="assignEmptyMessage"
      @success="getList"
    />

    <StudentShow :stuid="showstuid" v-on:setzero="showstuid = 0"></StudentShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import StudentShow from "@/components/StudentShow";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
export default {
  name: 'studentlist',
  components: {
    StudentShow,
    OtherDeptFollow,
    FollowDetailDialog,
    AssignResourceDialog,
    DeptRoleTeacherSelect,
  },
  data() {
    return {
      userIsAdmain: user.isAdmin(),
      userIsMarket: user.isMarket(),
      userIsAdviser: user.isAdviser(),
      userinfo:{},
      query: {},
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      // 其他部门跟进弹窗
      followDialogVisible: false,
      followType: '', // student | jap | mingye
      followDialogRow: {},
      total: 0,
      tableData: [],
      showstuid: 0,
      statelist: url.getStateData(),
      planList: url.getAbroadYear(),
      schoollist: [],
      edubacklist: url.getEduBack(),
      sourselist: [],
      selectedOrigion: [],
      adviserList: [],
      marketList: [],
      japlist: url.getJapLevelListForStu(), // 日语水平（统一数据）
      studentTypeList: url.getStudentTypeList(), // 学生/家长（筛选用）
      assignDialogVisible: false,
      assignForm: { resourceTypes: [], isStudent: false, isJap: false, isMingye: false },
      assignSubmiting: false,
    };
  },
  computed: {
    assignEmptyMessage() {
      var parts = [];
      if (!this.assignForm.isStudent) parts.push('留学');
      if (!this.assignForm.isJap) parts.push('日语');
      if (!this.assignForm.isMingye) parts.push('鸣野');
      if (parts.length === 0) return '该学生已是全部资源，无需分配';
      return '请选择分配给' + parts.join('或');
    },
  },
  methods: {
    canEditAny(row) {
      return user.canEditAny(row);
    },
    isAllAssignedNoAdviser(row) {
      return user.isAllAssignedNoAdviser(row);
    },
    //行样式
    tableRowClassName({ row, rowIndex }) {
      if (row.state === "c") {
        return "success-row";
      } else if (row.state === "e") {
        return "info-row";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //按状态查询
    stateClick: function () {
      this.getList();
    },
    //获取学校
    school: function () {
      var _this = this;
      var link = url.getCommon("getschool");
      $.get(link, {}, (data) => {
        _this.schoollist = data;
      });
    },
    //按学校查询
    schoolClick: function () {
      this.getList();
    },
    //来源
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist = data.originParam;
      });
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.inputStart = _this.query.daterange[0];
        params.inputEnd = _this.query.daterange[1];
      } else {
        params.inputStart = "";
        params.inputEnd = "";
      }
      if (_this.selectedOrigion.length > 0) {
        params.origin = _this.selectedOrigion[0];
        params.recName = _this.selectedOrigion[1];
      } else {
        params.origin = "";
        params.recName = "";
      }
      // 资源类型筛选：后端用 isStudent/isJap/isMingye，与留学跟进列表一致（已分配给留学的资源在留学列表能搜到）
      if (_this.query.resourceType === '留学') {
        params.isStudent = true;
      } else if (_this.query.resourceType === '日语') {
        params.isJap = true;
      } else if (_this.query.resourceType === '鸣野') {
        params.isMingye = true;
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      // 使用统一资源列表接口
      var link = url.getStu("getlist_base");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    // 弹窗展示其他部门跟进详情（统一组件）
    showFollowDialog: function(type, row) {
      this.followType = type;
      this.followDialogRow = row || {};
      this.followDialogVisible = true;
    },
    //编辑
    editClick: function (row) {
      // 跳转到统一录入页面进行编辑，保存后返回本列表
      this.$router.push({
        name: 'newstudent',
        query: { id: row.id, from: 'studentlist' }
      });
    },
    // 分配资源
    assignClick: function (row) {
      var _this = this;
      var currentUserID = user.getInfo() && (user.getInfo().userID != null ? user.getInfo().userID : user.getInfo().Id);
      _this.assignForm = {
        id: row.id,
        studentID: row.id,
        realName: row.realName,
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: row.isMingye || false,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: _this.userIsAdmain ? (row.marketID || null) : (currentUserID || null),
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: _this.userIsAdmain ? (row.jpMarketID || null) : (currentUserID || null),
        myAdviserID: row.myAdviserID || null,
        myMarketID: _this.userIsAdmain ? (row.myMarketID || null) : (currentUserID || null)
      };
      _this.assignDialogVisible = true;
    },
    //导出操作
    exportClick() {
      var _this = this;
      var params = _this.query;
      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      result.push("exportName=统一资源列表");
      var link = url.getStu("ExportVip") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    getInfo(){
      this.userinfo = user.getInfo();
      // console.log(this.userinfo);
    },
  },
  mounted() {
    var _this = this;
    _this.query = _this.$route.query;
    this.getInfo();
    // 来源
    _this.getAllOrigin();
    //获取学生列表
    this.getList();
    //获取学校
    this.school();
    // 顾问/营销老师：不再按板块获取，直接获取所有启用用户
    $.get(url.getStu("getenableusers"), (res) => {
      var list = res || [];
      _this.adviserList = list;
      _this.marketList = list;
    });
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.follow-detail-block div {
  margin-bottom: 10px;
  line-height: 1.6;
}
</style>


